import { Bar, BarChart, CartesianGrid, Cell, Legend, Line, LineChart, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const PALETTE = ['#0052CC', '#C9A227', '#00A3BF', '#00875A', '#4C6EF5'];
const AXIS = { stroke: '#94A3B8', fontSize: 11, tickLine: false, axisLine: false };
const TIP = { contentStyle: { background: '#0B2A5B', border: 'none', borderRadius: 8, color: '#F8FAFC', fontSize: 12 },
  itemStyle: { color: '#F8FAFC' }, labelStyle: { color: '#BFD3F2' }, cursor: { fill: 'rgba(0,82,204,0.06)' } };

const parse = (raw) => {
  try {
    const spec = JSON.parse(raw);
    if (!Array.isArray(spec?.data) || !spec.data.length) return null;
    const keys = spec.series?.length ? spec.series : Object.keys(spec.data[0]).filter((k) => k !== 'name' && typeof spec.data[0][k] === 'number');
    return keys.length ? { ...spec, keys } : null;
  } catch { return null; }
};

const Body = ({ spec }) => {
  if (spec.type === 'pie') {
    return (
      <PieChart>
        <Pie data={spec.data} dataKey={spec.keys[0]} nameKey="name" innerRadius={42} outerRadius={70} paddingAngle={2} stroke="none">
          {spec.data.map((d, i) => <Cell key={d.name} fill={PALETTE[i % PALETTE.length]} />)}
        </Pie>
        <Tooltip {...TIP} /><Legend iconType="circle" wrapperStyle={{ fontSize: 11 }} />
      </PieChart>
    );
  }
  const Chart = spec.type === 'line' ? LineChart : BarChart;
  return (
    <Chart data={spec.data} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
      <CartesianGrid stroke="#E2E8F0" strokeDasharray="3 3" vertical={false} />
      <XAxis dataKey="name" {...AXIS} /><YAxis {...AXIS} width={44} />
      <Tooltip {...TIP} />
      {spec.keys.length > 1 && <Legend iconType="circle" wrapperStyle={{ fontSize: 11 }} />}
      {spec.keys.map((k, i) => spec.type === 'line'
        ? <Line key={k} type="monotone" dataKey={k} stroke={PALETTE[i % PALETTE.length]} strokeWidth={2.5} dot={{ r: 3 }} activeDot={{ r: 5 }} />
        : <Bar key={k} dataKey={k} fill={PALETTE[i % PALETTE.length]} radius={[6, 6, 0, 0]} maxBarSize={36} />)}
    </Chart>
  );
};

export const MorganChart = ({ raw }) => {
  const spec = parse(raw);
  if (!spec) return <pre className="morgan-code">{raw}</pre>;
  return (
    <figure className="morgan-chart" data-testid="morgan-chart">
      {spec.title && <figcaption className="morgan-chart-title">{spec.title}</figcaption>}
      <div style={{ width: '100%', height: 190 }}>
        <ResponsiveContainer><Body spec={spec} /></ResponsiveContainer>
      </div>
    </figure>
  );
};

// react-markdown override: ```chart blocks become charts; tables get a scroll wrapper.
export const markdownComponents = {
  code({ className, children, ...rest }) {
    if (/language-chart/.test(className || '')) return <MorganChart raw={String(children).trim()} />;
    return <code className={className} {...rest}>{children}</code>;
  },
  pre({ children }) {
    const child = Array.isArray(children) ? children[0] : children;
    if (/language-chart/.test(child?.props?.className || '')) return <>{children}</>;
    return <pre className="morgan-code">{children}</pre>;
  },
  table({ children }) { return <div className="morgan-table-wrap"><table>{children}</table></div>; },
};
